import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styles: [`
    .confirm-container {
      padding: 20px;
      text-align: center;
    }
    .header, .dialog-message {
      text-transform: lowercase;
    }
    .header::first-letter, .dialog-message::first-letter {
      text-transform: uppercase;
    }

    .btn-sm {
      width: 100px;
      margin: 0 2px;
    }
  `]
})
export class ConfirmDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
                cancelText: string,
                confirmText: string,
                message: string,
                title: string
              },
              private mdDialogRef: MatDialogRef<ConfirmDialogComponent>) { }

  public cancel() {
    this.close(false);
  }

  public close(value) {
    this.mdDialogRef.close(value);
  }

  public confirm() {
    this.close(true);
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }

}
